module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/step1.3d36be9d.png";